<style scoped lang="less">
.caption-heading {
    font-size: 18px;
    font-weight: 600;
}
</style>
<template>
    <Promised :pending-delay="null" :promise="rootDataPromise" v-slot:combined="{ isPending, isDelayOver, data, error }">
        <template v-if="isPending && isDelayOver && data == null">
            <LoadingWheel :width="100" />
        </template>
        <template v-if="error != null">
            <div>An error occurred!</div>
        </template>
        <template v-if="data != null">
            <div class="admin-content container" role="region" aria-labelledby="DashboardHeading">
                <h1 class="admin-content-heading" id="DashboardHeading">Dashboard</h1>
                <div class="row">
                    <div class="col-lg-4 col-xl-3" v-if="(data.userData.CanReview || (showTestMode && data.userData.CanTestForms)) && hasPageworkflowFeature">
                        <Promised :pending-delay="null" :promise="getUrl('adminTasksIndex')" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminTasksIndex' })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-tasks">Tasks <span v-if="!data.userData.CanReview">(Test Only)</span></h3>
                                    <p class="card-text">View existing tasks and create new ones.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>
                    <div class="col-lg-4 col-xl-3" v-if="data.userData.CanReview || (showTestMode && data.userData.CanTestForms)">
                        <Promised :pending-delay="null" :promise="getUrl('adminSearch')" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminSearch' })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-submissions">Submissions <span v-if="!data.userData.CanReview">(Test Only)</span></h3>
                                    <p class="card-text">View form submissions and export to a spreadsheet.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>
                    <div class="col-lg-4 col-xl-3" v-if="data.userData.CanEditForms">
                        <Promised :pending-delay="null" :promise="getUrl('adminPageIndex')" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminPage' })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-sites">Sites</h3>
                                    <p class="card-text">Manage forms, <span v-if="hasPageworkflowFeature">workflows, </span>content, and folders.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>
                    <div class="col-lg-4 col-xl-3" v-if="data.userData.CanViewDataSources">
                        <Promised :pending-delay="null" :promise="getUrl('adminDataSources', { id: null })" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminDataSources', settings: { id: null } })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-data">Data Sources</h3>
                                    <p class="card-text">Manage data source tables referenced in web forms.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>
                    <!--
                <div class="col-lg-4 col-xl-3" v-if="data.userData.CanViewAddressBook">
                    <Promised :pending-delay="null" :promise="getUrl('adminAddressBook')" v-slot:combined="{data: resolvedUrl}">
                        <a @click.prevent="changePage({page:'AdminAddressBook'})" :href="resolvedUrl" class="card card-body admin-card">
                            <div class="caption">
                                <h3 class="caption-heading">Address Book</h3>
                                <p class="card-text">Manage contact groups referenced in contact forms.</p>
                            </div>
                        </a>
                    </Promised>
                </div>
                <div class="col-lg-4 col-xl-3" v-if="data.userData.CanImportForms">
                    <Promised :pending-delay="null" :promise="getUrl('adminFormImport')" v-slot:combined="{data: resolvedUrl}">
                        <a @click.prevent="changePage({page:'AdminFormImport'})" :href="resolvedUrl" class="card card-body admin-card">
                            <div class="caption">
                                <h3 class="caption-heading">Import Data</h3>
                                <p class="card-text">Import form data into the system.</p>
                                <span class="admin-icon icon-import"></span>
                            </div>
                        </a>
                    </Promised>
                </div>
                -->
                    <div class="col-lg-4 col-xl-3" v-if="data.userData.CanManageUsers">
                        <Promised :pending-delay="null" :promise="getUrl('adminUserManagementUsers')" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminUserManagementUsers' })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-users">User Management</h3>
                                    <p class="card-text">Manage users and groups within your portal.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>
                    <!-- <div class="col-lg-4 col-xl-3" v-if="data.userData.CanManageUsers && !hasUserManagementFeature">
                    <Promised :pending-delay="null" :promise="getUrl('adminUserManagementGroups')" v-slot:combined="{data: resolvedUrl}">
                        <a @click.prevent="changePage({page:'AdminUserManagementGroups'})" :href="resolvedUrl" class="card card-body admin-card">
                            <div class="caption">
                                <h3 class="caption-heading">Groups</h3>
                                <p class="card-text">Manage groups within your portal.</p>
                            </div>
                        </a>
                    </Promised>
                </div> -->
                    <div class="col-lg-4 col-xl-3" v-if="(data.userData.CanViewAllTenantsBilling || data.userData.CanViewTenantBilling) && hasBillingPageFeature">
                        <Promised :pending-delay="null" :promise="getUrl('adminBilling', { includeAllTenants: false, start: null, end: null })" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminBilling', settings: { includeAllTenants: false, start: null, end: null } })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-billing">Billing</h3>
                                    <p class="card-text">View billing for your portal.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>
                    <div class="col-lg-4 col-xl-3" v-if="data.userData.CanViewAllTenantsStats || (data.userData.CanViewTenantStats && hasTenantStatsFeature)">
                        <Promised :pending-delay="null" :promise="getUrl('adminStats', { includePageDetails: false, includeAllTenants: false, start: null, end: null })" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminStats', settings: { includePageDetails: false, includeAllTenants: false, start: null, end: null } })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-stats">Stats</h3>
                                    <p class="card-text">View stats for your portal.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>
                    <!--<div class="col-lg-4 col-xl-3" v-if="data.userData.CanViewFeatureFlags">
                        <Promised :pending-delay="null" :promise="getUrl('adminFeatureFlags')" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminFeatureFlags' })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-flag">Feature Flags</h3>
                                    <p class="card-text">Toggle features on and off.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>-->
                    <div class="col-lg-4 col-xl-3" v-if="data.userData.CanManageTenants">
                        <Promised :pending-delay="null" :promise="getUrl('adminTenantManagementIndex')" v-slot:combined="{ data: resolvedUrl }">
                            <a @click.prevent="changePage({ page: 'AdminTenantManagementIndex' })" :href="resolvedUrl" class="card card-body admin-card">
                                <div class="caption">
                                    <h3 class="caption-heading icon icon-lg-settings">Tenants</h3>
                                    <p class="card-text">Set up and manage tenants.</p>
                                </div>
                            </a>
                        </Promised>
                    </div>
                </div>
            </div>
        </template>
    </Promised>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
//import NonIndexStyles from '../lib/nonIndexStyles.3.vue';
import { useMainStore } from "@/mainStore";
import { Promised } from "@/lib/Promised";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import { computedAsync } from "@vueuse/core";
import { changePageInjectKey } from "@/AppShell.3.vue.InjectKeys";
export default defineComponent({
    components: {
        Promised,
        LoadingWheel,
    },
    props: ["settings"],
    emits: ["changePage", "updatePage"],
    setup() {
        const mainStore = useMainStore();
        return {
            showTestMode: computedAsync(() => mainStore.isFeatureFlagActiveAsync("TestMode"), null),
            hasTenantStatsFeature: computedAsync(() => mainStore.isFeatureFlagActiveAsync("TenantStats"), null),
            hasBillingPageFeature: computedAsync(() => mainStore.isFeatureFlagActiveAsync("BillingStatsPage"), null),
            hasPageworkflowFeature: computedAsync(() => mainStore.isFeatureFlagActiveAsync("PageWorkflow"), null),
            rootDataPromise: mainStore.userDataPromise.then(userData => ({ userData })),
            getUrl: mainStore.urlFetcher,
            changePage: inject(changePageInjectKey)!,
        };
    },
});
</script>
